export const AppEvents = {
  iframeInitialized: "iframeInitialized",
  validated: "validated",
  response: "response",
  error: "error",
  resizeIFrame: "resizeIFrame",
  installments: "getInstallments",
};

export const CpgmuiEvents = {
  execute: "execute",
  validate: "validate",
  custom: "custom",
  resizeIFrame: "resizeIFrame",
  installments: "installments",
};

export const ServiceOperations = {
  profileAdd: "profileAdd",
  newOrder: "newOrder",
  newOrderReversal: "newOrderReversal",
};

type CpgmuiEvent = {
  type: string;
  data: any;
};

export class Cpgmui {
  private targetOrigin;

  constructor(url: string) {
    const index = url.indexOf("/", "https://".length);
    this.targetOrigin = url.substring(0, index);
  }

  public iframeInitialized() {
    const cpgmuiEvent = {
      type: AppEvents.iframeInitialized,
      data: null,
    };
    this.postMessage(cpgmuiEvent);
  }
  public getInstallments(data: any) {
    const cpgmuiEvent = {
      type: AppEvents.installments,
      data,
    };
    this.postMessage(cpgmuiEvent);
  }
  public validated(data: any) {
    const cpgmuiEvent = {
      type: AppEvents.validated,
      data,
    };
    this.postMessage(cpgmuiEvent);
  }

  public response(data: any) {
    const cpgmuiEvent = {
      type: AppEvents.response,
      data,
    };
    this.postMessage(cpgmuiEvent);
  }

  public error(errors: Array<string>) {
    const cpgmuiEvent = {
      type: AppEvents.error,
      data: {
        errors,
      },
    };
    this.postMessage(cpgmuiEvent);
  }

  public resizeIFrame(data: any) {
    const cpgmuiEvent = {
      type: AppEvents.resizeIFrame,
      data,
    };
    this.postMessage(cpgmuiEvent);
  }

  private postMessage = (cpgmuiEvent: CpgmuiEvent) => {
    // window.top!.postMessage(cpgmuiEvent, this.targetOrigin);
    window.parent.postMessage(cpgmuiEvent, "*"); // NOSONAR
  };
}
